import './style.scss';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import {useGeographic} from 'ol/proj.js';
import {Circle, Fill, Stroke, Style, Text} from 'ol/style';
import {asArray} from 'ol/color';
import Overlay from 'ol/Overlay.js';
import {Geometry, Point, Polygon} from "ol/geom";
import {getBottomLeft, getBottomRight, getCenter, getTopLeft, getTopRight} from 'ol/extent';

useGeographic()

let layers = []

const menu = document.querySelector('#layerMenu');
const menuElem = document.querySelector('#menuContent')
const container = document.querySelector('#popup');
const content = document.querySelector('#popup-content');
const mobileContent = document.querySelector('#mobile-content');

document.querySelector('#toggleMenu').addEventListener('click', e => {
    e.stopPropagation()
    menu.classList.toggle('open')
})

menu.addEventListener('click', e => {
    if (!menu.classList.contains('open')) menu.classList.add('open')
})

const overlay = new Overlay({
    element: container,
    positioning: 'center-center',
    autoPan: {
        animation: {
            duration: 250,
        },
    },
});

container.addEventListener('pointermove', (e) => {
    e.stopPropagation();
})

const hoveredStyle = new Style({
    fill: new Fill({
        color: 'rgba(255,245,51,0.30)',
    }),
    stroke: new Stroke({
        color: 'rgb(255,0,0)',
        width: 2,
    }),
    text: new Text({
        font: '18px Calibri,sans-serif',
        overflow: true,
        fill: new Fill({
            color: '#f00',
        }),
        stroke: new Stroke({
            color: '#fff',
            width: 3,
        }),
    }),
});

const selectedStyle = new Style({
    fill: new Fill({
        color: 'rgba(108,231,64,0.30)',
    }),
    stroke: new Stroke({
        color: 'rgb(255,0,0)',
        width: 2,
    }),
    text: new Text({
        font: '18px Calibri,sans-serif',
        overflow: true,
        fill: new Fill({
            color: '#f00',
        }),
        stroke: new Stroke({
            color: '#fff',
            width: 3,
        }),
    }),
});

const map = new Map({
    target: 'map',
    layers: [
        new TileLayer({
            source: new OSM()
        })
    ],
    overlays: [overlay],
    view: new View({
        center: [lon, lat],
        zoom: zoom
    })
});

let selectedFeature = null;
map.on('click', function (e) {
    overlay.setPosition(undefined);

    if (selectedFeature) {
        selectedFeature.setStyle(undefined);
        selectedFeature = null;
    }

    const feature = map.forEachFeatureAtPixel(e.pixel, function (feature) {
        if (!feature.get('id')) return;

        if (hoveredFeature && hoveredFeature !== feature && hoveredFeature !== selectedFeature) {
            hoveredFeature.setStyle(undefined);
        }

        const id = feature.get('id');
        const nr = feature.get('nr');
        const position = feature.get('position');

        const backgroundStyle = new Style({
            stroke: selectedStyle.getStroke(),
            fill: selectedStyle.getFill(),
        });

        var extent = null
        if (feature.getGeometry().getType() === 'MultiPolygon') {
            extent = feature.getGeometry().getPolygons()[0].getExtent();
        }
        else {
            extent = feature.getGeometry().getExtent();
        }

        const textStyle = new Style({
            geometry: calculateMidpointFromExtent(extent, position),
            text: new Text({
                font: '18px Calibri,sans-serif',
                overflow: true,
                fill: new Fill({
                    color: '#f00',
                }),
                stroke: new Stroke({
                    color: '#fff',
                    width: 3,
                }),
                text: nr
            })
        });

        feature.setStyle([textStyle, backgroundStyle])

        return feature;
    });

    selectedFeature = feature

    mobileContent.classList.remove('open');

    if (!feature || !feature.get('id')) return;

    const coordinate = e.coordinate;

    const link_prod = 'https://geobuchhandlung.eshop.t-online.de/epages/Store3_Shop37170.sf/de_DE/?ObjectPath=/Shops/Shop37170/Products/' + feature.get('id');
    const link_pic = feature.get('pic_complete');
    const template = `
    <div class="underline popup-title">
        <a href="${link_prod}" target="_blank">${feature.get('name')}</a>
        <button class="closePopup"><span></span></button>
    </div>
    <a href="${link_prod}" target="_blank" class="popup-main">
        <img src="${link_pic}" alt="Produktabbildung">
        <div>
            ${feature.get('description')}
            <p class="popup-extra">
                Bestellung oder Information <br> durch weiteren Mausklick
            </p>
            <p class="popup-extra-mobile">
                Tippen für weitere Informationen.
            </p>
        </div>
    </a>`

    mobileContent.innerHTML = template;
    mobileContent.classList.add('open');
    content.innerHTML = template;

    document.querySelectorAll('.closePopup').forEach(e => e.addEventListener('click', (e) => {
            e.stopPropagation();
            if (selectedFeature) {
                selectedFeature.setStyle(undefined);
                selectedFeature = null;
            }
            mobileContent.classList.remove('open');
            overlay.setPosition(undefined);
        })
    );

    if (document.documentElement.clientWidth > 576) {
        overlay.setPosition(coordinate);
    }
});

let hoveredFeature = null;
map.on('pointermove', function (e) {
    if (hoveredFeature && hoveredFeature !== selectedFeature) {
        hoveredFeature.setStyle(undefined);
        hoveredFeature = null;
    }

    map.forEachFeatureAtPixel(e.pixel, function (feature) {
        if (!feature.get('id')) return;
        if (feature !== selectedFeature) {
            hoveredFeature = feature;
        } else {
            return;
        }

        const id = feature.get('id');
        const nr = feature.get('nr');
        const position = feature.get('position');

        const backgroundStyle = new Style({
            stroke: hoveredStyle.getStroke(),
            fill: hoveredStyle.getFill(),
        });

        var extent = null
        if (feature.getGeometry().getType() === 'MultiPolygon') {
            extent = feature.getGeometry().getPolygons()[0].getExtent();
        }
        else {
            extent = feature.getGeometry().getExtent();
        }

        const textStyle = new Style({
            geometry: calculateMidpointFromExtent(extent, position),
            text: new Text({
                font: '18px Calibri,sans-serif',
                overflow: true,
                fill: new Fill({
                    color: '#f00',
                }),
                stroke: new Stroke({
                    color: '#fff',
                    width: 3,
                }),
                text: nr
            })
        });

        feature.setStyle([textStyle, backgroundStyle])

        return feature;
    });
});

function colorWithOpacity(str, opacity) {
    const ctx = document.createElement('canvas').getContext('2d');
    ctx.fillStyle = str;
    let color = asArray(ctx.fillStyle);
    color[3] = opacity;
    return color;
}

function calculateMidpointFromExtent(extent, position = 'center') {
    // Get the coordinates of the extent
    const topLeft = getTopLeft(extent);
    const topRight = getTopRight(extent);
    const lowerLeft = getBottomLeft(extent);
    const lowerRight = getBottomRight(extent);
    const center = getCenter(extent);

    // Calculate the specified midpoint
    let newMidpoint;
    switch (position) {
        case 'center':
            newMidpoint = center;
            break;
        case 'topLeft':
            newMidpoint = [(topLeft[0] + 2 * center[0]) / 3, (topLeft[1] + 2 * center[1]) / 3];
            break;
        case 'topRight':
            newMidpoint = [(topRight[0] + 2 * center[0]) / 3, (topRight[1] + 2 * center[1]) / 3];
            break;
        case 'bottomLeft':
            newMidpoint = [(lowerLeft[0] + 2 * center[0]) / 3, (lowerLeft[1] + 2 * center[1]) / 3];
            break;
        case 'bottomRight':
            newMidpoint = [(lowerRight[0] + 2 * center[0]) / 3, (lowerRight[1] + 2 * center[1]) / 3];
            break;
        case 'left':
            newMidpoint = [(topLeft[0] + lowerLeft[0] + center[0]) / 3, (topLeft[1] + lowerLeft[1] + center[1]) / 3];
            break;
        case 'right':
            newMidpoint = [(topRight[0] + lowerRight[0] + center[0]) / 3, (topRight[1] + lowerRight[1] + center[1]) / 3];
            break;
        case 'top':
            newMidpoint = [(topLeft[0] + topRight[0] + center[0]) / 3, (topLeft[1] + topRight[1] + center[1]) / 3];
            break;
        case 'bottom':
            newMidpoint = [(lowerLeft[0] + lowerRight[0] + center[0]) / 3, (lowerLeft[1] + lowerRight[1] + center[1]) / 3];
            break;
        default:
            newMidpoint = center;
            break;
    }

    // Translate the original extent to the new midpoint
    const dx = newMidpoint[0] - center[0];
    const dy = newMidpoint[1] - center[1];
    const translatedExtent = [
        extent[0] + dx,
        extent[1] + dy,
        extent[2] + dx,
        extent[3] + dy
    ];

    // Create a new polygon geometry from the translated extent
    const newPolygon = new Polygon([
        [
            [translatedExtent[0], translatedExtent[1]], // Lower left
            [translatedExtent[2], translatedExtent[1]], // Lower right
            [translatedExtent[2], translatedExtent[3]], // Top right
            [translatedExtent[0], translatedExtent[3]], // Top left
            [translatedExtent[0], translatedExtent[1]]  // Close the polygon
        ]
    ]);

    return newPolygon;
}







async function init() {
    if (document.documentElement.clientWidth <= 768) menu.classList.remove('open')

    const response = await fetch("data/index.json");
    const data = await response.json();

    specific.active.forEach(((identifier) => {
        const d = data.find(obj => obj.identifier === identifier)
        const isVisible = specific.visible.includes(identifier)
        const layer = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON(),
                url: `data/${d.map}`,
            }),
            visible: isVisible,
            style: (feature, resolution) => {
                const fillColor = feature.get('fillColor');
                const strokeColor = feature.get('strokeColor');
                const id = feature.get('id');
                const nr = feature.get('nr');
                const position = feature.get('position');

                // Basic style for all polygons
                const basicStyle = new Style({
                    stroke: new Stroke({
                        width: id !== undefined ? 1 : 3,
                        color: strokeColor
                    }),
                    fill: new Fill({
                        color: colorWithOpacity(fillColor, 0.2)
                    })
                });

                const geom = feature.getGeometry();
                const backgroundStyle = new Style({
                    stroke: basicStyle.getStroke(),
                    fill: basicStyle.getFill(),
                });

                let textStyle = null;
                if (id !== undefined && geom.getType() === 'MultiPolygon') {
                    const polys = geom.getPolygons();
                    const extent = polys[0].getExtent();

                    textStyle = new Style({
                        geometry: calculateMidpointFromExtent(extent, position),
                        text: new Text({
                            font: '16px Calibri,sans-serif',
                            overflow: false,
                            fill: new Fill({
                                color: '#000',
                            }),
                            stroke: new Stroke({
                                color: '#fff',
                                width: 3,
                            }),
                            text: nr,
                        }),
                    });
                }
                else if (id !== undefined && geom.getType() === 'Polygon'){
                    const extent = geom.getExtent();

                    textStyle = new Style({
                        geometry: calculateMidpointFromExtent(extent, position),
                        text: new Text({
                            font: '16px Calibri,sans-serif',
                            overflow: false,
                            fill: new Fill({
                                color: '#000',
                            }),
                            stroke: new Stroke({
                                color: '#fff',
                                width: 3,
                            }),
                            text: nr
                        })
                    })
                }

// If it's not a MultiPolygon or there's no id, set basic style for the feature
                return textStyle !== null ? [backgroundStyle, textStyle] : basicStyle;

            }
        });

        const nextId = layers.push(layer)
        map.addLayer(layer)

        const template = `<div class="layerOption">
            <input type="checkbox" id="layer-${nextId - 1}" data-id="${nextId - 1}" ${isVisible ? 'checked' : ''}/>
            <label for="layer-${nextId - 1}">${d.name}</label>
        </div>`

        menuElem.insertAdjacentHTML('beforeend', template)
    }));

    document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => checkbox.addEventListener('input', e => {
        layers[e.target.dataset['id']].setVisible(e.target.checked)
    }))

}

init();

